// MarkdownCardWrapper.tsx
import React from "react";

export const MarkdownCard = ({ node, children, ...props }: any) => {
  // Intentamos leer flags desde node (hProperties) o desde props (cuando viene HTML raw)
  const nodeProps =
    (node && (node.data?.hProperties || node.properties)) || (props || {});
    
    

  const dataNoCard =
    nodeProps["dataNoCard"] === true ||
    nodeProps["dataNoCard"] === "true" ||
    nodeProps["data-no-card"] === true ||
    nodeProps["data-no-card"] === "true" ||
    nodeProps["dataType"] === "timeline" ||
    nodeProps["data-type"] === "timeline" ||
    nodeProps["dataType"] === "timeline";

  if (dataNoCard) {
    // No aplicar el wrapper visual, devolver el div tal cual
    return <div {...props}>{children}</div>;
  }

  // Wrapper por defecto
  return (
    <div className="bg-white rounded-xl shadow-md p-4 mb-4 border border-gray-100" {...props}>
      {children}
    </div>
  );
};
